module.exports = require('./helpers/bundle-url').getBundleURL('ak0ox') + "Inter-italic.var.6edd0203.woff2";